import React from 'react'
import { isBrowser } from 'src/utils/env'
import { isEmpty } from 'src/utils/string'
import { InformationalDialog } from '@jarvis.oddle/core/components/Dialog'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { useRouter } from 'next/router'
import { makeControlledModal } from 'src/decorators/ModalController'

const CheckoutErrorDialog = ({
  error
}: {
  error: { errorCode?: string } | { errorCode?: string }[]
}): JSX.Element => {
  const { t } = React.useContext(TranslationContext)
  const router = useRouter()

  const onConfirm = () => {
    if (isBrowser()) {
      window.location.href = `/${router.query.locale}`
    }
  }

  return error ? (
    <InformationalDialog
      show={error}
      header={t('Unable to checkout')}
      body={t('Please fix the following errors before checkout:')}
      subText={
        <ul>
          {(Array.isArray(error) ? error : [error]).map((e) => (
            <li key={e.errorCode}>
              {!isEmpty(e.errorCode) ? t(e.errorCode) : t('error_general')}
            </li>
          ))}
        </ul>
      }
      confirmText={t('Back To Cart')}
      onConfirm={onConfirm}
    />
  ) : null
}

export default makeControlledModal(CheckoutErrorDialog, 'CheckoutErrorDialog')
